import { ArrayProjectFn, DictionaryProjectFn, getProjectFn } from './internal'

/**
 * Simple array map (wraps native Array#map)
 */
export function _map<T, R>(collection: Array<T>, project: ArrayProjectFn<T, R>): R[];

/**
 * Object pick - pick the given key from each object in the given array
 */
export function _map<T, K extends keyof T>(collection: Array<T>, project: K): Array<T[K]>;

/**
 *  Simple object map (takes each Key-Value from the given object and maps the value) - Returns an array
 *  @see _mapObj for a version that does not return an array
 */
export function _map<T extends object, R>(collection: T, project: DictionaryProjectFn<T, R>): R[];

/**
 * Object pick for lookup objects - pick the given key from each object.
 * (Objects that are are found at each key of the supplied 'collection' object.)
 */
export function _map<T extends object, K extends keyof T[keyof T]>(collection: T, project: K): Array<(T[keyof T])[K]>;

/**
 * Null | undefined will return an empty array
 */
export function _map<T, R>(collection: undefined | null, project: any): R[];

/**
 * Override implementation.
 */
export function _map<T, R>(collection: any, project: any): R[] {
	if (!collection) return [] // Don't try to simplify this - Remember typeof null === 'object'
	project = getProjectFn(project)
	if (Array.isArray(collection)) {
		return collection.map(project)
	} else if (typeof collection === 'object') {
		return Object.keys(collection).map(key => project(collection[key], key, collection))
	}
	return []
}
